
import { Component, Vue } from 'vue-property-decorator'
import { DOTCMS_CONTENT_ID } from '../../const'
import { DotCMSService } from '../../services'

  @Component({
    name: 'TermsAndConditions'
  })

export default class TermsAndConditions extends Vue {
    termsTitle:string[] = [
      'Terms and Conditions Part 1',
      'Part 2: Terms and conditions for use of Car Finance 247'
    ]

    termsAndConditions:string[] = DOTCMS_CONTENT_ID.TERMS_AND_CONDITIONS
    content:any = {}

    mounted () {
      DOTCMS_CONTENT_ID.TERMS_AND_CONDITIONS.forEach(id => DotCMSService.getContentById(id, 1).then((response) => {
        if (response.data && response.data.contentlets.length > 0) {
          const id = response.data.contentlets[0].identifier
          this.content[id] = response.data.contentlets[0]
          this.$forceUpdate()
        }
      }))
    }

    // #region Methods

    navToPrivacyPolicy () {
      this.$emit('openModal', 'privacy-policy')
    }

    navToCookiePolicy () {
      this.$emit('openModal', 'cookie-policy')
    }

    agreeAndClose () {
      this.$emit('agree-to-terms')
    }

  // #endregion
}
